namespace Dashboard {
    class DashboardHome {
        private alerts: INotification[];
        constructor(
            private dashboardNotificationService: IDashboardNotificationService,
            private $interpolate: ng.IInterpolateService,
            private $location: ng.ILocationService) {
            this.dashboardNotificationService.getNotifications()
                .then((data) => { this.alerts = data; });
        }

        private notificationClicked = (n) => {
            this.dashboardNotificationService.notificationClicked(n);
        }

        private formatNotification = (n) => this.dashboardNotificationService.formatNotification(n);
    }

    angular
        .module('dashboard')
        .controller('Dashboard', DashboardHome);
}
